import React from 'react';
import LoanCalculator from './components/LoanCalculator';
import './App.css';

const App = (props) => {
  // Create appConfig from props or use defaults
  const appConfig = {
    productApiUrl: props.apiUrl,
    productId: props.offerId,
    applyUrl: props.applyUrl,
    loanAmountLabel: props.loanAmountLabel,
    monthlyLabel: props.monthlyLabel || "Monthly Installment",
    durationLabel: props.durationLabel || "Duration",
    infoLinkLabel: props.infoLinkLabel || null,
    submitLabel: props.submitLabel || "Apply Now",
    footerText: props.footerText,
    loginLabel: props.loginLabel,
    monthsLabel: props.monthsLabel,
    apiErrorMessage: props.apiErrorMessage,
    warningTitle: props.warningTitle,
    warningContent: props.warningContent,
    numDecimalMonthly: props.numDecimalMonthly,
    siteCurrency: props.siteCurrency,
    onlyApplyButton: props.onlyApplyButton,
    applyButtonId: props.applyButtonId,
    hideDuration: props.hideDuration,
    creditAccountLabel: props.creditAccountLabel,
    fullDisclosureMode: props.fullDisclosureMode,
    totalAmountLabel: props.totalAmountLabel,
    representativeExampleTemplate: props.representativeExampleTemplate,
    costBreakdownEnabled: props.costBreakdownEnabled,
    aprLabel: props.aprLabel || "APR",
    interestLabel: props.interestLabel || "Interest",
    commissionLabel: props.commissionLabel || "Commission",
    costDetailsToggleLabel: props.costDetailsToggleLabel || "Cost details",
    totalLoanAmountLabel: props.totalLoanAmountLabel || "Total loan amount",
    totalCostLabel: props.totalCostLabel || "Total cost of credit"
  };

  return (
    <div className="App">
      <LoanCalculator appConfig={appConfig} />
    </div>
  );
};

export default App;
